import styled from "styled-components"

export const CommunityWrapper = styled.div`
  margin-top: 32px;

  h6 {
    font-size: 16px;
    margin-bottom: 8px;
    color: #4d5157;
    line-height: 20px;
    font-weight: 560;
    padding: 0 24px;
  }

  @media (min-width: 1024px) {
    h6 {
      padding: 0 40px;
    }
  }
`
